<template>
  <section>

    <div
      class="modal-card"
      style="width: auto"
    >
      <header class="modal-card-head">
        <p><img src="@/assets/Quest_long_logo.png"></p>
      </header>

      <div v-if="!isForgot">
        <section class="modal-card-body">
          <!-- <b-message type="is-success" has-icon v-if="this.forgotMessage">
                        {{ this.forgotMessage }}
                    </b-message> -->

          <h1 class="subtitle is-bold">Sign in to your account</h1>
          <b-field label="Email">
            <input
              @focus="$event.target.select()"
              class="input"
              type="email"
              v-model="email"
              placeholder="Your email"
              required
              v-focus
              @keyup.enter="signin()"
            />
          </b-field>

          <b-field label="Password">
            <input
              @focus="$event.target.select()"
              class="input"
              type="password"
              v-model="password"
              password-reveal
              placeholder="Your password"
              required
              @keyup.enter="signin()"
            />
          </b-field>

          <!-- <b-message title="System Down Notification" type="is-danger">
            Amazon AWS is having a major system wide outage. Lifestyles Quest is hosted on Amazon AWS making it offline until Amazon fixes the issues. This is affecting Netflix, Apple TV, and other major services as well as Quest.&nbsp;<a href="https://status.aws.amazon.com/" target="_blank">CLICK HERE FOR STATUS UPDATES FROM AMAZON</a>
          </b-message> -->

          <b-message
            type="is-danger"
            has-icon
            v-if="this.$store.state.signinError"
          >
            {{ this.$store.state.signinError }}
          </b-message>
        </section>
        <section class="modal-card-body is-size-7">
          Lifestyles Quest is a service of Lifestyles Realty, Inc. Access to Lifestyles Quest is<br>restricted to clients and/or customers of Lifestyles Realty, Inc. TREC #568459.
        </section>
        <footer class="modal-card-foot">
          <button
            v-if="!isForgot"
            class="button is-primary"
            @click="signin()"
          >Sign in</button>
          <button
            v-if="!isForgot"
            class="button is-text"
            @click="isForgot = !isForgot"
          >Forgot your password?</button>
        </footer>
      </div>

      <div v-if="isForgot">
        <section class="modal-card-body">
          <h1 class="subtitle is-bold">Enter your email and we'll send your password</h1>
          <b-field label="Email">
            <input
              @focus="$event.target.select()"
              class="input"
              type="email"
              v-model="email"
              placeholder="Your email"
              required
              v-focus
              @keyup.enter="forgotpassword()"
            />
          </b-field>
          <b-message
            type="is-danger"
            has-icon
            v-if="this.$store.state.signinError"
          >
            {{ this.$store.state.signinError }}
          </b-message>
        </section>
        <footer class="modal-card-foot">
          <button
            v-if="isForgot"
            class="button is-primary"
            @click="forgotpassword(email)"
          >Send password</button>
          <button
            v-if="!isForgot"
            class="button is-text"
            @click="isForgot = !isForgot"
          >Forgot your password?</button>
          <button
            v-if="isForgot"
            class="button is-text"
            @click="isForgot = !isForgot"
          >Go back to sign in</button>
        </footer>
      </div>

    </div>

  </section>
</template>

<script>
export default {
  data() {
    return {
      email: "",
      password: "",
      forgotMessage: "",
      isForgot: false
    };
  },
  methods: {
    async signin() {
      this.forgotMessage = "";
      this.$store.state.signinError = "";
      var email = this.email;
      var password = this.password;
      await this.$store.dispatch("signin", { email, password }).then(
        r => {
          // eslint-disable-next-line no-undef
          profitwell("start", { user_id: r.data.user.chargifyId });

          // Success, update the main menu.
          this.$router.go(this.$router.currentRoute);
        },
        async error => {
          console.log("signin()", error);
          if (error && error.response && error.response.status == 403) {
            console.log(
              "!!!signin.error",
              error,
              error.response,
              error.response.data,
              error.response.data.id
            );
            await this.$store.commit(
              "SET_REACTIVATION_USERID",
              error.response.data.id
            );
            this.$store.state.reactivateUserId = error.response.data.id;
            console.log(this.$store.state.reactivateUserId);
            await this.$store.commit(
              "SET_LIBERATOR_ERROR",
              "Your subscription isn't active, please reactivate it now"
            );
            await this.$router.push({
              name: "Signup",
              params: {
                property_id: this.$store.state.property.id,
                evaluation_id: this.$store.state.evaluation.id
              }
            });
            this.showInfo(
              "Your Quest subscription isn't active, let's reactivate it. Enter your email below to get started.",
              30000
            );
          } else this.showError(error);
        }
      );
    },
    async forgotpassword(email) {
      console.log("forgotpassword()", email);
      await this.$store.dispatch("forgotPassword", email);
      if (!this.$store.state.liberatorError) {
        this.forgotMessage = `Password sent to ${email}`;
        this.$store.state.signinError = "";
        this.isForgot = false;
        this.$store.commit("SET_LIBERATOR_SUCCESS", this.forgotMessage);
      }
    }
  }
};
</script>

<style>
</style>
